import { FC, useEffect, useMemo, useState } from "react";
import "./Pricing.scss";
import { Card, Col, Container, Row } from "react-bootstrap";
import MainNavbar from "../../components/MainNavbar/MainNavbar";
import { usePlans } from "../../providers/Financial/Plans/PlansProvider";
import { PlansModel } from "../../models/Financial/Plans/PlansModel";
import { ReactComponent as Brain } from "../../assets/icons/icon-brain.svg";
import { ReactComponent as BrainWhite } from "../../assets/icons/icon-brain-white.svg";
import { BvIcon } from "bevi-icon";
import FormatNumber from "../../utils/FormatNumber";
import useEmblaCarousel from "embla-carousel-react";
import { useMediaQuery } from "react-responsive";
import { useCheckout } from "../../providers/Checkout/CheckoutProvider";
import { useNavigate } from "react-router-dom";

interface PricingProps {}

const Pricing: FC<PricingProps> = () => {
  const [period, setPeriod] = useState<boolean>(false);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "center",
    containScroll: "keepSnaps",
  });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const {
    setParams,
    params,
    plans,
    handleListArticlesPlatform,
    handleListContentArticles,
    articlePlatform,
    contentArticles,
  } = usePlans();

  const navigate = useNavigate();

  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      withPaginate: true,
      filter: { only_active: false },
    });
    handleListArticlesPlatform();
    handleListContentArticles();
  }, []);

  const sortedPlansMobile = useMemo(() => {
    const filtered = plans
      ?.filter((plan) => !plan.deleted_at)
      .sort((a: any, b: any) => a.id - b.id);

    if (!filtered) return [];

    const advancedIndex = filtered.findIndex((p) => p.name === "Avançado");

    if (advancedIndex === -1) return filtered;

    const advancedPlan = filtered.splice(advancedIndex, 1)[0];

    filtered.splice(1, 0, advancedPlan);

    return filtered;
  }, [plans]);

  const sortedPlans = useMemo(() => {
    return plans
      ?.filter((plan) => !plan.deleted_at)
      .sort((a: any, b: any) => a.id - b.id);
  }, [plans]);

  const handlehire = (x: PlansModel) => {
    const plan = {
      plan_id: x?.id,
      name: x?.name,
      typePlan: period ? "Mensal" : "Anual",
      price: period
        ? x?.plan_prices?.filter((pri: any) => pri?.cycle === "monthly")[0]
            ?.price || 0
        : x?.plan_prices?.filter((pri: any) => pri?.cycle === "annual")[0]
            ?.price || 0,
      max_users: x?.max_users,
    };
    localStorage.setItem("checkoutOk", "true");
    localStorage.setItem("selectedPlan", JSON.stringify(plan));
    navigate("/checkout/list");
  };

  useEffect(() => {
    if (!emblaApi) return;

    const update = () => {
      const selected = emblaApi.selectedScrollSnap();

      emblaApi.slideNodes().forEach((slide, index) => {
        slide.classList.toggle("is-selected", index === selected);
      });
    };

    emblaApi.on("select", update);
    emblaApi.on("reInit", update);

    update();

    return () => {
      emblaApi.off("select", update);
      emblaApi.off("reInit", update);
    };
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi || !sortedPlansMobile?.length) return;

    const index = sortedPlansMobile.findIndex((p) => p.name === "Avançado");

    if (index !== -1) {
      emblaApi.scrollTo(index, true);
    }
  }, [emblaApi, sortedPlansMobile]);

  const renderPlanCard = (x: PlansModel) => {
    return (
      <Card
        className="mb-5"
        style={{
          backgroundColor: x?.name === "Avançado" ? "#222343" : "#FFFFFF",
          position: "relative",
          bottom: isMobile ? "0" : x?.name === "Avançado" ? "20px" : "0",
          top: isMobile ? (x?.name === "Avançado" ? "10px" : "0") : "",
        }}
      >
        {x?.name === "Avançado" && (
          <div className="d-flex justify-content-center text-center">
            <div className="recommended">
              <span className="recommended-text">Recomendado</span>
            </div>
          </div>
        )}
        <Card.Body>
          <div
            className={`${x?.name === "Avançado" ? "mt-0" : "mt-4"} d-flex flex-column align-items-center justify-content-center`}
          >
            <h3 className="lh-1">{x?.name}</h3>
            <h6
              className="lh-1"
              style={{
                color: x?.name === "Avançado" ? "#E3E1EA" : "",
              }}
            >
              até {x?.max_users} usuários
            </h6>
            <span
              className="description mt-4"
              style={{
                color: x?.name === "Avançado" ? "#FFFFFF" : "",
              }}
            >
              {x?.description}
            </span>
          </div>

          <div className="d-flex flex-column align-items-center justidy-content-center">
            <h4 className="mt-4">
              {!period && (
                <>
                  <span>
                    R$
                    {FormatNumber(
                      x?.plan_prices?.filter(
                        (pri: any) => pri?.cycle === "monthly",
                      )[0]?.price || 0,
                    )}
                  </span>
                </>
              )}
            </h4>
            <div className="d-flex align-items-center justidy-content-center">
              <h2
                style={{
                  color: x?.name === "Avançado" ? "#25CBDB" : "",
                }}
              >
                R$
                {FormatNumber(
                  period
                    ? x?.plan_prices?.filter(
                        (pri: any) => pri?.cycle === "monthly",
                      )[0]?.price || 0
                    : x?.plan_prices?.filter(
                        (pri: any) => pri?.cycle === "annual",
                      )[0]?.price || 0,
                )}
              </h2>
              <b
                style={{
                  color: x?.name === "Avançado" ? "#25CBDB" : "#454787",
                }}
              >
                /mês*
              </b>
            </div>
            {!period && (
              <span className="annual-payment">
                Pagamento anual de R$
                {FormatNumber(
                  x?.plan_prices?.filter(
                    (pri: any) => pri?.cycle === "annual",
                  )[0]?.price * 12,
                )}
              </span>
            )}

            <button
              onClick={() => handlehire(x)}
              className="button-hire mt-4"
              style={{
                background: x?.name === "Avançado" ? "#25CBDB" : "",
              }}
            >
              Contratar
            </button>
          </div>

          <div className="d-flex flex-column mt-4">
            <div className="d-flex align-items-center">
              {x?.name === "Avançado" ? (
                <BrainWhite width={24} height={24} className="me-2" />
              ) : (
                <Brain width={24} height={24} className="me-2" />
              )}
              <h5
                style={{
                  color: x?.name === "Avançado" ? "#25CBDB" : "",
                }}
              >
                IA (Inteligência Artificial)
              </h5>
            </div>
            {contentArticles?.map((inf: any, index) => (
              <div className="d-flex mt-3 align-items-center">
                <div>
                  {x?.name === "Básico" ? (
                    <BvIcon
                      style={{ color: "#444688" }}
                      name="cancel"
                      width={24}
                      height={24}
                    />
                  ) : (
                    <BvIcon
                      style={{
                        color: x?.name === "Avançado" ? "#25CBDB" : "",
                      }}
                      variant={`${x?.name === "Avançado" ? "light" : "duo"}`}
                      name="checkCircle"
                      width={24}
                      height={24}
                      className="me-2"
                    />
                  )}
                </div>
                <span
                  className={`${x?.name === "Básico" ? "articles-info" : "articles-info-qualified"} ms-2`}
                >
                  {index === 0 ? (
                    x?.name === "Básico" ? (
                      inf.content
                    ) : (
                      <span
                        style={{
                          color: x?.name === "Avançado" ? "#F1F2F3" : "",
                        }}
                      >
                        {x?.message_limit} mensagens mensais
                      </span>
                    )
                  ) : (
                    <span
                      style={{
                        color: x?.name === "Avançado" ? "#F1F2F3" : "",
                      }}
                    >
                      {inf.content}
                    </span>
                  )}
                </span>
              </div>
            ))}
          </div>
          <hr className="mt-4 mb-4" />
          <div>
            <div className="d-flex align-items-center">
              <BvIcon
                style={{
                  color: x?.name === "Avançado" ? "#FFFFFF" : "",
                }}
                variant={`${x?.name === "Avançado" ? "light" : "duo"}`}
                name="article"
                width={24}
                height={24}
                className="me-2"
              />
              <h5
                style={{
                  color: x?.name === "Avançado" ? "#25CBDB" : "",
                }}
              >
                Plataforma de Artigos
              </h5>
            </div>
            {articlePlatform?.map((art: any) => (
              <div className="d-flex mt-3 align-items-center">
                <div>
                  <BvIcon
                    style={{
                      color: x?.name === "Avançado" ? "#25CBDB" : "",
                    }}
                    variant={`${x?.name === "Avançado" ? "light" : "duo"}`}
                    name="checkCircle"
                    width={24}
                    height={24}
                  />
                </div>
                <span
                  style={{
                    color: x?.name === "Avançado" ? "#F1F2F3" : "",
                  }}
                  className="articles-info-qualified ms-2"
                >
                  {art?.article}
                </span>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    );
  };

  return (
    <>
      <MainNavbar />
      <div className="Pricing" data-testid="Pricing">
        <Container className="mt-6">
          <Row>
            <Col md={12}>
              <div className="d-flex flex-column align-items-center">
                <span className="lh-1 title-info">
                  Tire dúvidas operacionais em segundos e acelere suas vendas.
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex flex-column align-items-center mt-4">
                <span className="subTitle-info">
                  O bevIAjuda reúne regras e informações operacionais do
                  consignado para ajudar você a tirar dúvidas com rapidez
                  enquanto atende o cliente.
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex flex-column align-items-center mt-4 now-ia">
                <span>Agora com IA para responder suas dúvidas.</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex align-items-center justify-content-center mt-4">
                <div className="border-am">
                  <button
                    className={`${period ? "monthly" : "annual"}`}
                    onClick={() => setPeriod(false)}
                  >
                    Anual <span className="promotional ms-1">PROMOCIONAL</span>
                  </button>
                  <button
                    onClick={() => setPeriod(true)}
                    className={`${!period ? "monthly" : "annual"}`}
                  >
                    Mensal
                  </button>
                </div>
              </div>
            </Col>
          </Row>

          {isMobile ? (
            <div className="embla mt-6" ref={emblaRef}>
              <div className="embla__container">
                {sortedPlansMobile?.map((x) => (
                  <div className="embla__slide" key={x.id}>
                    {renderPlanCard(x)}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Row className="mt-6">
              {sortedPlans?.map((x) => (
                <Col md={3} key={x.id}>
                  {renderPlanCard(x)}
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};

export default Pricing;
